import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxPaginationModule } from 'ngx-pagination';

import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { IconsModule } from '@shared/icons/icons.module';
import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { PaymentButtonExternalModule } from '@shared/payment-button-external/payment-button-external.module';
import { MutualModule } from '@shared/mutual/mutual.module';
import { BillListAdminComponent } from './components';
import { BillListUserComponent } from './components/bill-list-user/bill-list-user.component';
import { BillStatusComponent } from './components/bill-status/bill-status.component';
import { BillItemIconComponent } from './components/bill-item-icon/bill-item-icon.component';
import { BillItemsManagementListComponent } from './components/bill-items-management-list/bill-items-management-list.component';
import { BillsMonitoringComponent } from './components/bills-monitoring/bills-monitoring.component';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';
import { PaymentButtonSharedModule } from '@shared/payment-button-shared';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    BillListAdminComponent,
    BillListUserComponent,
    BillStatusComponent,
    BillItemIconComponent,
    BillItemsManagementListComponent,
    BillsMonitoringComponent,
  ],
  imports: [
    CommonModule,
    BsDatepickerModule,
    PipesSharedModule,
    IconsModule,
    RouterModule,
    PaymentButtonExternalModule,
    CustomModalModule,
    MutualModule,
    NgxPaginationModule,
    TranslateModule,
    FormWrapperModule,
    FlexLayoutModule,

    PaymentButtonSharedModule,
  ],
  exports: [BillListAdminComponent, BillListUserComponent, BillStatusComponent, BillItemsManagementListComponent, BillsMonitoringComponent],
})
export class BillSharedModule {}
